export function unregisterAllServiceWorkers(): void {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
            registrations.forEach(registration => {
                registration.unregister()
            })
        })
    }
}
